import axios from "axios";

const apiClient = () => {
  const requestHeaders = { "Content-Type": "application/json" };

  requestHeaders[
    "Authorization"
  ] = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxODI2OTQ1MzI2LCJpYXQiOjE3NDA1NDUzMjYsImp0aSI6ImQyY2VlYWY2OWVlMjQyNzdiYTg0MTM1MTUwMzE3YjJlIiwidXNlcl9pZCI6M30.o9ZG3rsfq1g0qq1PmbbDGgVVtwoQTcpj4Mc6QWQ-PK8`;

  const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}`,
    responseType: "json",
    headers: requestHeaders,
    timeout: 100000,
  });
  return axiosInstance;
};

export default apiClient;
